// extracted by mini-css-extract-plugin
export var container = "_cn-0";
export var popoverContent = "_cn-1";
export var tosLink = "_cn-2";